module.exports = __webpack_public_path__ + "images/records_quota.svg";